module.exports = __webpack_public_path__ + "img/DNARepair-LICA_PLC.013eded8.png";